const formatTimelineTimestamp = (value: number) => {
  const totalSeconds = Math.max(0, Math.round(value))
  const minutes = Math.floor(totalSeconds / 60)
  const seconds = totalSeconds % 60
  return `${minutes}:${seconds.toString().padStart(2, '0')}`
}

const rightRoundedRectPath = (
  x: number,
  y: number,
  width: number,
  height: number,
  radius: number,
) => {
  const clampedRadius = Math.max(0, Math.min(radius, height / 2, width))
  if (clampedRadius === 0) {
    return `M ${x} ${y} H ${x + width} V ${y + height} H ${x} Z`
  }
  return [
    `M ${x} ${y}`,
    `H ${x + width - clampedRadius}`,
    `Q ${x + width} ${y} ${x + width} ${y + clampedRadius}`,
    `V ${y + height - clampedRadius}`,
    `Q ${x + width} ${y + height} ${x + width - clampedRadius} ${y + height}`,
    `H ${x}`,
    'Z',
  ].join(' ')
}

export { formatTimelineTimestamp, rightRoundedRectPath }
